import {
  MAINNET_RELAY_API,
  type RelayClient,
  type RelayClientOptions,
  convertViemChainToRelayChain,
  createClient,
  getClient,
} from '@reservoir0x/relay-sdk'
import type { Chain } from 'viem'
import type { Logger } from './types'

export type InitializeRelayClientParams = Omit<
  RelayClientOptions,
  'baseApiUrl' | 'chains' | 'logger'
> & {
  chains: Chain[]
  logger: Logger
}

/**
 * Initializes a global instance of the RelayClient
 * https://docs.relay.link/references/sdk/createClient
 */
export function initializeRelayClient({
  chains,
  logger,
  ...options
}: InitializeRelayClientParams): RelayClient {
  return createClient({
    ...options,
    baseApiUrl: MAINNET_RELAY_API,
    chains: chains.map(convertViemChainToRelayChain),
    logger: (message) => {
      logger.info('[RelayClient]:', message)
    },
  })
}

/**
 * Gets the global instance of the RelayClient
 */
export function getRelayClient(): RelayClient {
  const client = getClient()

  if (!client) {
    throw new Error('Relay client is not defined')
  }

  return client
}
